var map = {
	"./aberto.png": 3582,
	"./cintura.png": 7321,
	"./normal.png": 7152,
	"./pensativo.png": 2208,
	"./pensativo2.png": 9024,
	"./um.png": 9691,
	"./unhas.png": 4438
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2180;